export default __webpack_public_path__ + "resources/icons/d500-2305.webp";